import { TKey } from "@/app/translations/TKey";
import { FAQKeys } from "@/app/types/common/FAQKeys";
import { Globals } from "@/app/vars/Globals";

const IS_WAITLIST = Globals.WAITLIST_ENABLED;

export const MEIDLY_FAQ: FAQKeys = {
  supTitle: TKey.FAQ,
  title: TKey.FAQ_TITLE,
  items: [
    IS_WAITLIST
      ? {
          titleKey: TKey.FAQ_MEIDLY_ACCESS_TITLE,
          descriptionKeys: [TKey.FAQ_MEIDLY_ACCESS_TEXT, TKey.FAQ_MEIDLY_ACCESS_TEXT_2],
        }
      : {
          titleKey: TKey.FAQ_MEIDLY_START_TITLE,
          descriptionKeys: [TKey.FAQ_MEIDLY_START_TEXT, TKey.FAQ_MEIDLY_START_TEXT_2],
        },
    {
      titleKey: TKey.FAQ_MEIDLY_3_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_3_TEXT, TKey.FAQ_MEIDLY_3_TEXT_2],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_2_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_2_TEXT, TKey.FAQ_MEIDLY_2_TEXT_2, TKey.FAQ_MEIDLY_2_TEXT_3],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_TEAM_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_TEAM_TEXT, TKey.FAQ_MEIDLY_TEAM_TEXT_2],
    },
    {
      titleKey: TKey.FAQ_MEIDLY_6_TITLE,
      descriptionKeys: [TKey.FAQ_MEIDLY_6_TEXT, TKey.FAQ_MEIDLY_6_TEXT_2, TKey.FAQ_MEIDLY_6_TEXT_3],
    },
    { titleKey: TKey.FAQ_MORE_TITLE, descriptionKeys: [TKey.FAQ_MORE_TEXT] },
  ],
};

export function frenchSpacing(text: string): string {
  return text.replace(/ ([?!:;»])/g, " $1");
}
